import IconDown from '../icons/down';
import { CategoriesListTypes } from './types';
import Checkbox from '../checkbox/checkbox';

import styles from './accounts-selector.module.css';

export default function CategoriesList({
  accounts,
  setSelectedCategoryId,
  primaryAccountsSelector,
  setSelectedPrimaryAccounts,
  selectedPrimaryAccountsList,
}: CategoriesListTypes) {
  return (
    <>
      <li className={styles.accountListTitle}>Category</li>
      {accounts?.map((item) => {
        const currentSelectedPrimaryAccounts: string[] = [];
        const currentCategoryPrimaryAccounts: string[] = [];

        if (primaryAccountsSelector) {
          item.accountGroups?.forEach((group) => {
            group?.primaryAccounts?.forEach((primary) => {
              currentCategoryPrimaryAccounts.push(primary.id);
            });
          });

          selectedPrimaryAccountsList?.forEach((selectedPrimary) => {
            if (
              currentCategoryPrimaryAccounts.find(
                (currentPrimary) => currentPrimary === selectedPrimary,
              )
            ) {
              currentSelectedPrimaryAccounts.push(selectedPrimary);
            }
          });
        }

        return (
          <li
            key={item.id}
            className={
              primaryAccountsSelector
                ? styles.primaryAccountsSelectorListItem
                : ''
            }
          >
            <div
              className={
                primaryAccountsSelector ? styles.categoryButtonWrapper : ''
              }
            >
              {primaryAccountsSelector && setSelectedPrimaryAccounts && (
                <div className={styles.selectAllCheckboxWrapper}>
                  <Checkbox
                    name={`category-${item.id}`}
                    type="checkbox"
                    title=""
                    checked={Boolean(
                      currentSelectedPrimaryAccounts.length ===
                      currentCategoryPrimaryAccounts.length,
                    )}
                    partialChecked={Boolean(
                      currentSelectedPrimaryAccounts.length > 0 &&
                      currentSelectedPrimaryAccounts.length <
                        currentCategoryPrimaryAccounts.length,
                    )}
                    onChange={(e) => {
                      let nextSelectedPrimaryAccounts = ([] as string[]).concat(
                        selectedPrimaryAccountsList as string[],
                      );

                      if (e.target.checked) {
                        item.accountGroups?.forEach((group) => {
                          group.primaryAccounts?.forEach((primary) => {
                            if (
                              !nextSelectedPrimaryAccounts.find(
                                (selected) => selected === primary.id,
                              )
                            ) {
                              nextSelectedPrimaryAccounts.push(primary.id);
                            }
                          });
                        });
                      } else {
                        nextSelectedPrimaryAccounts =
                          nextSelectedPrimaryAccounts.filter(
                            (selectedPrimary) =>
                              currentCategoryPrimaryAccounts.every(
                                (currentPrimary) =>
                                  currentPrimary !== selectedPrimary,
                              ),
                          );
                      }

                      setSelectedPrimaryAccounts(nextSelectedPrimaryAccounts);
                    }}
                  />
                </div>
              )}
              <button
                type="button"
                className={`${styles.categoryButton} ${primaryAccountsSelector ? styles.primaryAccountsSelectorButton : ''}`}
                onClick={() => setSelectedCategoryId(item.id)}
                tabIndex={-1}
              >
                <div className={styles.categoryButtonLeft}>{item.name}</div>
                <div className={styles.categoryButtonRight}>
                  <div className={styles.categoryButtonNumber}>
                    {item.number}
                  </div>
                  <div className={styles.categoryButtonArrow}>
                    <IconDown
                      className={styles.arrowRight}
                      width={12}
                      height={9}
                    />
                  </div>
                </div>
              </button>
            </div>
          </li>
        );
      })}
    </>
  );
}
